// extracted by mini-css-extract-plugin
export default {"container":"MenuGroupModal--container--baeb68","description":"MenuGroupModal--description--1d1c09","descLabel":"MenuGroupModal--descLabel--de030a"};